import { useState } from 'react';
import { PermissionsMap } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Fetches the permissions catalog (categorized PermissionsMap) for use when
 * creating or editing a Role. Calls /account/users/permissions-new with the
 * supplied email, then resets every permission's `permitted` flag to false so
 * the drawer starts with nothing selected.
 */
export default function useFetchRolePermissionsCatalog() {
  const [fetching, setFetching] = useState(false);
  const [catalog, setCatalog] = useState<PermissionsMap>({});

  async function fetchCatalog(emailAddress: string) {
    try {
      setFetching(true);
      const res = await api.fetchAccountUserPermissionsNew({ EmailAddress: emailAddress });
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      // Reset every permission to unselected for role creation.
      const blankCatalog: PermissionsMap = {};
      Object.entries(res.Permissions).forEach(([groupName, group]) => {
        blankCatalog[groupName] = {};
        Object.entries(group).forEach(([permKey, item]) => {
          blankCatalog[groupName][permKey] = { label: item.label, permitted: false };
        });
      });

      setCatalog(blankCatalog);
      return blankCatalog;
    } catch (error) {
      console.error('Fetch role permissions catalog failed:', error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, catalog, fetchCatalog };
}
